import { WithDeleted } from '@common/typescript/objects/WithDeleted';
import { WithFile } from '@common/typescript/objects/WithFile';
import { Nullable } from '@common/typescript/objects/Nullable';

import { Gender } from '@commonTuna/react/objects/Enums';

import { Patient, PatientDocumentValidity } from '@app/objects/Patient';
import { CardImageType } from '@app/objects/CardImageType';

export enum RelationshipToLicenseHolderEnum {
	Self,
	Spouse,
	Child,
	Other
}

export const RelationshipToLicenseHolderEnumNames = {
	[RelationshipToLicenseHolderEnum.Self]: 'Self',
	[RelationshipToLicenseHolderEnum.Spouse]: 'Spouse',
	[RelationshipToLicenseHolderEnum.Child]: 'Child',
	[RelationshipToLicenseHolderEnum.Other]: 'Other',
};

export interface DrivingLicenseImage extends WithFile<DrivingLicense> {
	cardImageType: CardImageType;
}

export interface DrivingLicense extends WithDeleted {
	patient: Nullable<Patient>;
	patientId: number | null;

	driverNumber: string;

	photoFront: string;
	photoBack: string;

	drivingLicenseValidity: PatientDocumentValidity;

	portalId: Nullable<number>;

	subscriberFirstName: string;
	subscriberLastName: string;
	subscriberMiddleName: string;
	subscriberGender: Gender;
	subscriberDateBirth: Nullable<number>;
	relationshipToLicenseHolder: RelationshipToLicenseHolderEnum;

	files: Array<DrivingLicenseImage>;
}
